<app-modal-shell title="Manage Services" size="sm" [closeDisabled]="saving" (closed)="close()">
  <div icon class="header-icon">
    <i class="bi bi-sliders"></i>
  </div>

  @if (loading) {
    <app-loader />
  } @else {
    <p class="modal-subtitle">
      Turn services on or off for <strong>{{ user?.email }}</strong>.
    </p>

    @if (rows.length === 0) {
      <p class="empty-hint">No active services are configured for this tenant.</p>
    } @else {
      <div class="service-list">
        @for (row of rows; track row.tenantServiceId) {
          <div class="toggle-row">
            <div class="toggle-label">{{ row.serviceName }}</div>
            <label class="switch">
              <input type="checkbox" [checked]="row.checked" [disabled]="saving" (change)="toggle(row)" />
              <span class="switch-track"><span class="switch-thumb"></span></span>
            </label>
          </div>
        }
      </div>
    }
  }

  <div footer>
    <button type="button" class="cancel-btn" [disabled]="saving" (click)="close()">Cancel</button>
    <button type="button" class="submit-btn" [disabled]="saving || !hasChanges" (click)="save()">
      @if (saving) { <span class="spinner"></span> Saving... } @else { <i class="bi bi-check-lg"></i> Save }
    </button>
  </div>
</app-modal-shell>
